export const informationTypes = [
  // { id: 1, name: '资讯', english: 'INFORMATION' },
  // { id: 2, name: '活动', english: 'ACTIVITY' },
  // { id: 3, name: '动态', english: 'DYNAMIC' }
]
